import { ClientCommand, ClientResponseModel, useCreateClientFunctionRequest } from "shared/request/myHealthyAdvantageApi";
import { ClientForm } from "../../Components/ClientForm/ClientForm";
import ErrorAlert from "shared/UI/Alerts/ErrorAlert";
import { getServerErrorMessage } from "shared/utils/serverError";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNotifyModalContext } from "shared/core/state/NotifyModalContext/NotifyModalContext";

const viewClientsPath = "/clientmanagement";

export const CreateClient = () => {
  const { t } = useTranslation();
  const { modalNotify } = useNotifyModalContext();
  const navigateHook = useNavigate();
  const { trigger: createClientRequest } = useCreateClientFunctionRequest({});

  const [createClientErrorMessage, setCreateClientErrorMessage] = useState<string | null>(null);

  const onSubmit = async (clientDetails: ClientCommand, navFunction?: (response?: ClientResponseModel) => void) => {
    setCreateClientErrorMessage("");
    try {
      const response = await createClientRequest({ body: clientDetails });
      modalNotify("success", t("clientForm.successTitle"), t("clientForm.successMessage", { clientName: clientDetails.name, action: "created" }));
      navFunction ? navFunction(response?.data) : navigateHook(viewClientsPath);
    } catch (error: any) {
      setCreateClientErrorMessage(getServerErrorMessage(error, t("clientForm.requestErrorMessage", { clientFormAction: "creating" })));
    }
  };

  return (
    <>
      <ClientForm onSubmit={onSubmit} />
      {createClientErrorMessage && <ErrorAlert content={createClientErrorMessage} />}
    </>
  );
};
